import { styled } from '@mui/material';
import { DialogInfoTypography } from './DialogInfoTypography';

export const DialogInfoTypographyBold = styled(DialogInfoTypography)({
  fontWeight: 600,
}); 